// export const BFF_URL = window.RUNTIME_CONFIG?.REACT_APP_BFF_URL;
export const BFF_URL = window.RUNTIME_CONFIG?.REACT_APP_BFF_URL || process.env.REACT_APP_BFF_URL;
export const POST = 'POST';
